import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatMessageErrorUtilityClass(slot) {
  return generateUtilityClass('MuiChatMessageError', slot);
}
export const chatMessageErrorClasses = generateUtilityClasses('MuiChatMessageError', ['root', 'message', 'retryButton']);
const slots = {
  root: ['root'],
  message: ['message'],
  retryButton: ['retryButton']
};
export const useChatMessageErrorUtilityClasses = classes => composeClasses(slots, getChatMessageErrorUtilityClass, classes);